import qs from 'qs'
import fetch from '../utils/Fetch'
import config from '@/config/Config.vue'


//下单
export function placeAnOrder(data) {
    return fetch({
        url: config.WEB_PLACEANORDER_API,
        method: 'POST',
        data: qs.stringify(data)
    })
}

export function placeCanOrder(data) {
    return fetch({
        url: config.WEB_PLACECANORDER_API,
        method: 'POST',
        data: qs.stringify(data)
    })
}

//下单
export function placeDisperserOrder(data) {
    return fetch({
        url: config.WEB_PLACEDISPERSERORDER_API,
        method: 'POST',
        data: qs.stringify(data)
    })
}
//取消订单
export function cancelOrder(data) {
    return fetch({
        url: config.WEB_CANCELORDER_API,
        method: 'POST',
        data: qs.stringify(data)
    })
}
//手动入场
export function manualEnter(data) {
    return fetch({
        url: config.WEB_MANUALENTER_API,
        method: 'POST',
        data: qs.stringify(data)
    })
}
//手动离场
export function manualLeave(data) {
    return fetch({
        url: config.WEB_MANUALLEAVE_API,
        method: 'POST',
        data: qs.stringify(data)
    })
}
//取消弹框订单
export function cancelOrderConfirm(data) {
    return fetch({
        url: config.WEB_CANCELORDERCONFIRM_API,
        method: 'POST',
        data: qs.stringify(data)
    })
}
//订单列表
export function orderList(data) {
    return fetch({
        url: config.WEB_ORDERLIST_API,
        method: 'POST',
        data: qs.stringify(data)
    })
}
//订单详情
export function orderListByDetails(data) {
    return fetch({
        url: config.WEB_ORDERLISTBYDETAILS_API,
        method: 'POST',
        data: qs.stringify(data)
    })
}
// 启动充电
export function startCharge(data) {
    return fetch({
        url: config.WEB_START_CHARGE_API,
        method: 'POST',
        data: qs.stringify(data)
    })
}
// 停止充电
export function stopCharge(data) {
    return fetch({
        url: config.WEB_STOP_CHARGE_API,
        method: 'POST',
        data: qs.stringify(data)
    })
}
//用户未完成的订单跳转
export function userOrderStatus(data) {
    return fetch({
        url: config.WEB_USERORDERSTATUS_API,
        method: 'POST',
        data: qs.stringify(data)
    })
}

//订单状态
export function orderStatus(data) {
    return fetch({
        url: config.WEB_ORDER_STATUS_API,
        method: 'POST',
        data: qs.stringify(data)
    })
}

//去支付
export function goPay(data) {
    return fetch({
        url: config.WEB_GOPAY_API,
        method: 'POST',
        data: qs.stringify(data)
    })
}
